import { Routes, Route } from "react-router-dom";
import LayoutRoot from "./pages/Root";
import Page from "./pages/Page";
import Deepdive from "./pages/Deepdive";

// Top-level lijstpagina's. Nieuwe tab toevoegen? 1 regel hier + de story in Storyblok.
const listPages = [
  "trainingen",
  "boeken",
  "lezingen",
  "coaching",
  "shop",
  "downloads",
];

function App() {
  return (
    <Routes>
      <Route path="/" element={<LayoutRoot />}>
        <Route index element={<Page slug="home" />} />
        {listPages.map((slug) => (
          <Route key={slug} path={slug} element={<Page slug={slug} />} />
        ))}
        <Route path="*" element={<Deepdive />} />
      </Route>
    </Routes>
  );
}

export default App;
